import React from "react";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import "./styles/book_visit.sass";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BookVisit = ({ setBookVisit }) => {
  return (
    <div className='dark_bgc'>
      <div className='phone_number_alert'>
        <h2>Zadzwoń już teraz!</h2>
        <FontAwesomeIcon icon={faPhone} className='vibrating' />
        <h1>+48 533 340 065</h1>
        <button onClick={() => setBookVisit(false)}>x</button>
      </div>
    </div>
  );
};

export default BookVisit;
